import {AxiosInstance} from "axios";

/**
 * Api for Xero authorization.
 */
export default class XeroAuthApi {
	constructor(public readonly axiosInstance: AxiosInstance) {}

	/**
	 * Get url of Xero authorization page.
	 * @returns {Promise<string>}
	 */
	fetchAuthorizationPageUrl(): Promise<string> {
		const url = `/api/web/accounting/xero/authorize_app`;
		return this.axiosInstance.get(url).then(resp => resp.data);
	}
}
